import { COMING_SOON_QUESTION_IDS } from "./questions";
import { LIVE_QUESTION_IDS, loadLiveQuestionData } from "./liveData";
import { assertQuestionPrivilege } from "./privileges";

export async function loadQuestionData(questionId, vehicleId, liveContext) {
  assertQuestionPrivilege(questionId);

  if (COMING_SOON_QUESTION_IDS.has(questionId)) {
    return { comingSoon: true };
  }

  if (LIVE_QUESTION_IDS.has(questionId)) {
    const data = await loadLiveQuestionData(questionId, vehicleId, liveContext);
    return data || {};
  }

  throw new Error(`Unknown FleetBot question: ${questionId}`);
}
